// @flow
import baseStyled from 'styled-components'
import theme from './theme'

const styled = baseStyled

export { theme, styled }
